import React, {ReactElement} from "react";
import {Box, Typography} from "@mui/material";

interface IProps {
    video: string;
    description?: string;
}

function ProjectVideo({video, description}: IProps): ReactElement {

    return <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        sx={{
            position: 'relative',
            width: '100%',
            paddingBottom: '56.25%', // 16:9 aspect ratio (100% / (16 / 9) = 56.25%)
            height: 0,
            overflow: 'hidden',
        }}
    >
        <Box
            component="iframe"
            src={`${video}${'?vq=hd720'}`}
            sx={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
                border: 0
            }}
            allowFullScreen
            title="Responsive iframe"
        />

        {description ?
            <Typography
                id={'ImageName'}
                variant={"subtitle1"}
                sx={{
                    textAlign: 'center',
                    fontStyle: 'italic',
                }}
            >
                {description}
            </Typography>
            : null
        }

    </Box>

}

export default ProjectVideo;
